// extracted by mini-css-extract-plugin
export default {"segment":"CountdownTimer__segment--ig-WKAY_","day":"CountdownTimer__day--ig-yVC7j"};